import React from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button/standard-button';
import InfoIcon from '@atlaskit/icon/glyph/info';
import { Box, xcss } from '@atlaskit/primitives';
import { B500 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { useIntlV2 as useIntlDI } from '@atlassian/jira-intl';
import { useProjectKey } from '@atlassian/jira-issue-context-service';

import messages from './messages';

type Props = {
	useIntl?: typeof useIntlDI;
};

const NoIssuesFeedback = ({ useIntl = useIntlDI }: Props) => {
	const { formatMessage } = useIntl();

	const baseUrl = '';
	const projectKey = useProjectKey();
	const redirectUrl = `${baseUrl}/jira/servicedesk/projects/${projectKey}/issues`;

	const renderErrorIcon = () => (
		<Box xcss={infoIconWrapperStyles}>
			<InfoIcon label="info" primaryColor={token('color.text.information', B500)} />
		</Box>
	);

	const renderTryAgainLink = () => (
		<Button
			appearance="link"
			target="_blank"
			href={redirectUrl}
			interactionName="auto-generated.jira-smart-related-issues-panel.ui.issue-line-card-group.no-issues-feedback.button"
		>
			{formatMessage(messages.searchLink)}
		</Button>
	);

	return (
		<NoIssuesFeedbackContainer>
			{renderErrorIcon()}
			{formatMessage(messages.errorMessage)}
			{renderTryAgainLink()}
		</NoIssuesFeedbackContainer>
	);
};

export default NoIssuesFeedback;

const infoIconWrapperStyles = xcss({
	marginRight: 'space.100',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const NoIssuesFeedbackContainer = styled.div({
	display: 'flex',
	alignItems: 'center',
});
